export const IconButtonStyling = {
    defaultProps: {
        colorScheme: "blackAlpha !important"
    }
};